import { makeStyles } from 'tss-react/mui'
import { darkThemeBg, primaryDrawingColor } from '../../../assets/colors'


const useStyles = makeStyles()((theme) => ({
    chartContainer: {
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    chart: {
        margin: 0,
        padding: 0,
        flex: '1 1 0',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
    },
    chartMount: {
        flex: '1 1 0',
        minHeight: 0,
        width: '100%',
    },
    chartShimmerOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 5,
        pointerEvents: 'none',
    },
    chartMetadataPlaceholder: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 6,
        pointerEvents: 'none',
    },
    chartFooter: {
        position: 'relative',
        flexShrink: 0,
        zIndex: 10,
        overflow: 'visible'
    },
    replaySelectionMode: {
        '&::after': {
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '\"\"',
            background: theme.palette.mode === "dark" ? darkThemeBg: '#fff',
            opacity: 0.7,
            zIndex: 1
        }
    },
    replayBackdrop: {
        position: 'absolute',
        top: 0,
        right: 0,
        pointerEvents: 'none',
        borderLeft: `2px solid ${primaryDrawingColor}`,
        width: 0,
        height: '0',
        zIndex: 2,
        display: 'none',

        '&::after': {
            content: '\"\"',
            display: 'block',
            height: '100%',
            width: '100%',
            opacity: 0.7,
            backgroundColor: theme.palette.mode === "dark" ? 'black' : 'white'
        }
    },
    scissorIcon: {
        position: 'absolute',
        left: '0',
        width: '24px',
        marginTop: '-12px',
        marginLeft: '-13px',
        color: theme.palette.mode === "dark" ? 'white' : 'black',
        zIndex: 1
    }
}))

export default useStyles